import { FrameWorkChange, FrameWorkGetDefaulValue, FrameWorkGetMapFromItem, FrameWorkGetPrimaryColorButton, FrameWorkGetSecundaryColorButton, FrameWorkHideAlert, FrameWorkMessageErrorAlert, FrameWorkMessageSuccessAlert, FrameWorkPutTextToActiveInactiveUser, FrameWorkPutValueIfEditByDefault, FrameWorkSimpleMessageState, FrameWorkVerifyDataIsCompleted } from 'orden_express/frameWork/frameWork';
import { setMessageSaveStateProduct } from 'orden_express/products/productsActions.js';
import { requestGetMeasureUnit, requestGetProductCategory, requestSaveProduct } from 'orden_express/products/productsEpic.js';
import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Button, Card, CardBody, CardFooter, CardHeader, CardTitle, FormGroup, Input, Label } from 'reactstrap';
import { bindActionCreators } from 'redux';


class UsersDeliveryPoint extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      id: '',
      code: '',
      name: '',
      measureUnit: '',
      quantityAvailable: '',
      category: '',
      information: '',
      icon: '',
      active: '',
      idState: '',
      codeState: '',
      nameState: '',
      measureUnitState: '',
      quantityAvailableState: '',
      categoryState: '',
      informationState: '',
      iconState: '',
      activeState: '',

    };
  }

  componentDidMount() {
    this.props.setMessageSaveStateProduct(0);
    this.props.requestGetProductCategory();
    this.props.requestGetMeasureUnit();
    let localProductForEdit = this.props.productsReducerState.dataProductForEdit;
    FrameWorkPutValueIfEditByDefault(this, 'id', localProductForEdit, 'id', 'have-content', 0);
    FrameWorkPutValueIfEditByDefault(this, 'code', localProductForEdit, 'code', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'name', localProductForEdit, 'name', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'measureUnit', localProductForEdit, 'measureUnit', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'quantityAvailable', localProductForEdit, 'quantityAvailable', 'have-content', 0);
    FrameWorkPutValueIfEditByDefault(this, 'category', localProductForEdit, 'category', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'information', localProductForEdit, 'information', 'have-content', 0);
    FrameWorkPutValueIfEditByDefault(this, 'icon', localProductForEdit, 'icon', 'have-content', 0);
    FrameWorkPutValueIfEditByDefault(this, 'active', localProductForEdit, 'active', 'have-content', 1);
    if (localProductForEdit === null) {
      this.setState({ active: 1 });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.productsReducerState.messageSaveStateProduct !== prevProps.productsReducerState.messageSaveStateProduct) {
      this.processMessageState(this.props.productsReducerState.messageSaveStateProduct);
    }
  }

  getDataFromForm = () => {
    const localProduct = {
      id: this.state.id,
      code: this.state.code,
      name: this.state.name,
      measureUnit: this.state.measureUnit,
      quantityAvailable: this.state.quantityAvailable,
      category: this.state.category,
      information: this.state.information,
      icon: this.state.icon,
      active: 1,
    };
    localProduct.active = 0;
    if (this.state.active) {
      localProduct.active = 1;
    }
    return localProduct;
  }

  /**
   * Valida los campos obligatorios y ayuda a determinar
   * en ellos con un color o etiqueta visual para que el 
   * usuario los identifique
   */
  verifyData = () => {
    var dataIsCompleted = true;
    const listValidation = [
      'codeState',
      'nameState',
      'categoryState',
      'measureUnitState',
      'quantityAvailable'
    ];
    var pos = 0;
    var length = listValidation.length;
    while (pos < length) {
      var item = listValidation[pos];
      if (FrameWorkVerifyDataIsCompleted(this.state[item])) {
        dataIsCompleted = false;
        this.setState({ [item]: 'has-danger' });
      }
      pos++;
    }
    /*listValidation.map((item, index) => {
      if (FrameWorkVerifyDataIsCompleted(this.state[item])) {
        dataIsCompleted = false;
        this.setState({ [item]: 'has-danger' });
      }
    });*/
    if (!dataIsCompleted) {
      FrameWorkMessageErrorAlert(this, 'Faltan datos', 'Debe ingresar todos los datos solicitados')
      return;
    }
    //Al llear a este punto es que todos los datos han sido ingresados y se procede a su registro
    this.props.requestSaveProduct(this.getDataFromForm());
    this.props.setMessageSaveStateProduct(1);
  };

  /**
   * Controla la secuencia de estados para visualizar 
   * los mensajes en el proceso de almacenamiento de un producto
   */
  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Grabando', 'Su solicitud está en proceso ...');
        break;
      case 2:
        FrameWorkMessageSuccessAlert(this, 'Correcto!', 'Los datos fueron correctamente almacenados', this.props.history.goBack, this.props.history.goBack);
        break;
      case 3:
        var localMessageError = this.props.productsReducerState.responseSaveProduct;
        FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
        console.error(localMessageError)
        break;
      default:
        FrameWorkHideAlert(this);
        this.props.setMessageSaveStateProduct(0);
        break;
    }
  }
  /**
   * Pinta los contenidos basados en los estados
   */
  render() {
    let {
      codeState,
      nameState,
      measureUnitState,
      categoryState,
      iconState,
      quantityAvailableState,
    } = this.state;
    let localProductEdit = this.props.productsReducerState.dataProductForEdit;
    var localProductCategory = [];
    try {
      localProductCategory = FrameWorkGetMapFromItem(this.props.productsReducerState.responseGetProductCategory, 'result');
      let errorLocalProductCategory = this.props.productsReducerState.responseGetProductCategory.errorState;
      if (errorLocalProductCategory === true || errorLocalProductCategory === 'true') {
        localProductCategory = [];
      }
    } catch (_) { }
    var localMeasureUnit = [];
    try {
      localMeasureUnit = FrameWorkGetMapFromItem(this.props.productsReducerState.responseGetMeasureUnit, 'result');
      let errorLocalMeasureUnit = this.props.productsReducerState.responseGetMeasureUnit.errorState;
      if (errorLocalMeasureUnit === true || errorLocalMeasureUnit === 'true') {
        localMeasureUnit = [];
      }
    } catch (_) { }
    return (
      <div className='content'>
        {this.state.alert}
        <Card>
          <CardHeader>
            <CardTitle tag='h5'>Datos del producto</CardTitle>
          </CardHeader>
          <CardBody>

            <Input
              name='id'
              type='text'
              value={FrameWorkGetDefaulValue(localProductEdit, 'id')}
              hidden
              readOnly
            />

            <FormGroup className={`has-label ${codeState}`}>
              <label>Código *</label>
              <Input
                name='code'
                type='text'
                maxLength='40'
                defaultValue={FrameWorkGetDefaulValue(localProductEdit, 'code')}
                onChange={e => FrameWorkChange(this, e.target.value, 'code', 'have-content', '1')}
              />
              {this.state.codeState === 'has-danger' ? (
                <label className='error'>
                  Ingrese el código
                        </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${nameState}`}>
              <label>Nombre *</label>
              <Input
                name='name'
                type='text'
                maxLength='40'
                defaultValue={FrameWorkGetDefaulValue(localProductEdit, 'name')}
                onChange={e => FrameWorkChange(this, e.target.value, 'name', 'have-content', '1')}
              />
              {this.state.nameState === 'has-danger' ? (
                <label className='error'>
                  Ingrese el nombre
                        </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${categoryState}`}>
              <label>Categoría *</label>
              <Select
                className={`react-select ${categoryState === 'has-danger' ? 'bg-danger-drop-down' : ''}`}
                classNamePrefix='react-select'
                name='category'
                placeholder='Seleccione la categoría'
                value={
                  (this.state.selectCategory === '' ||
                    this.state.selectCategory === undefined ||
                    this.state.selectCategory === null) ?
                    { value: FrameWorkGetDefaulValue(localProductEdit, 'category'), label: FrameWorkGetDefaulValue(localProductEdit, 'nameCategory') }
                    : this.state.selectCategory}
                options={
                  localProductCategory.map((itemProductCategory, indexProductCategory) => {
                    return (
                      { value: itemProductCategory.id, label: itemProductCategory.name }
                    )
                  })
                }
                onChange={value => {
                  this.setState({ selectCategory: value });
                  FrameWorkChange(this, value.value, 'category', 'have-content', '1');
                }
                }
              />
              {this.state.categoryState === 'has-danger' ? (
                <label className='error'>
                  Seleccione la categoría
                        </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${measureUnitState}`}>
              <label>Unidad de medida *</label>
              <Select
                className={`react-select ${measureUnitState === 'has-danger' ? 'bg-danger-drop-down' : ''}`}
                classNamePrefix='react-select'
                name='category'
                placeholder='Seleccione la categoría'
                value={
                  (this.state.selectMeasureUnit === '' ||
                    this.state.selectMeasureUnit === undefined ||
                    this.state.selectMeasureUnit === null) ?
                    { value: FrameWorkGetDefaulValue(localProductEdit, 'measureUnit'), label: FrameWorkGetDefaulValue(localProductEdit, 'nameMeasureUnit') }
                    : this.state.selectMeasureUnit}
                options={
                  localMeasureUnit.map((itemMeasureUnit, indexMeasureUnit) => {
                    return (
                      { value: itemMeasureUnit.id, label: itemMeasureUnit.name }
                    )
                  })
                }
                onChange={value => {
                  this.setState({ selectMeasureUnit: value });
                  FrameWorkChange(this, value.value, 'measureUnit', 'have-content', '1');
                }
                }
              />
              {this.state.measureUnitState === 'has-danger' ? (
                <label className='error'>
                  Seleccione la unidad de medida
                        </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${quantityAvailableState}`}>
              <label>Cantidad mínima requerida para el pedido *</label>
              <Input
                name='quantityAvailable'
                type='number'
                //value={FrameWorkGetDefaulValue(localProductEdit, 'quantityAvailable')}
                defaultValue={FrameWorkGetDefaulValue(localProductEdit, 'quantityAvailable')}
                onChange={e => FrameWorkChange(this, e.target.value, 'quantityAvailable', 'have-content', '1')}

              />
              {this.state.quantityAvailableState === 'has-danger' ? (
                <label className='error'>
                  {'Ingrese la cantidad mínima requerida para el pedido'}
                </label>
              ) : null}
            </FormGroup>

            <FormGroup>
              <label>Información</label>
              <Input
                className='textarea'
                name='information'
                type='textarea'
                maxLength='300'
                cols='80'
                rows='4'
                defaultValue={FrameWorkGetDefaulValue(localProductEdit, 'information')}
                onChange={e => FrameWorkChange(this, e.target.value, 'information', 'have-content', 1)}
              />
            </FormGroup>

            <FormGroup className={`has-label ${iconState}`}>
              <label>{/*Ícono*/} </label>
              <Input
                name='icon'
                type='text'
                maxLength='100'
                defaultValue={FrameWorkGetDefaulValue(localProductEdit, 'icon')}
                onChange={e => FrameWorkChange(this, e.target.value, 'icon', 'have-content', 0)}
                hidden
              />
              {this.state.iconState === 'has-danger' ? (
                <label className='error'>
                  {/*Ingrese el ícono del producto*/}
                </label>
              ) : null}
            </FormGroup>

            <FormGroup check className='mt-2'>
              <Label check className='has-danger'>
                <Input
                  name='active'
                  type='checkbox'
                  defaultChecked={localProductEdit === null ? 1 : FrameWorkGetDefaulValue(localProductEdit, 'active')}
                  onChange={value => { this.setState({ active: !this.state.active }); }}
                />
                <span className='form-check-sign' />
                {FrameWorkPutTextToActiveInactiveUser(this.state.active, 1)}
              </Label>
            </FormGroup>

            <div className='category form-category'>
              * Campos obligatorios
              </div>

          </CardBody>

          <CardFooter className='text-right'>
            <Button
              style={{ width: 145 }}
              color={FrameWorkGetSecundaryColorButton()}
              className='btn-round mb-0' onClick={() => {
                try {
                  this.props.history.goBack();
                } catch (_) { }
              }}>
              <i className='icon-big nc-icon nc-minimal-left text-white' />
              Regresar
                </Button>
            <Button
              className='btn-round mt-1 mb-0 ml-4'
              color={FrameWorkGetPrimaryColorButton()}
              style={{ width: 145 }}
              onClick={
                this.verifyData
              }>
              <i className='icon-big fa fa-save text-white' />
              Grabar
                </Button>
          </CardFooter>
        </Card>
      </div>
    );
  }
}
/**
 * Gracias a este método se tiene acceso al repositorio de estados único,
 * para este caso se usa el del producto
 * @param {*} state 
 */
const mapStateToProps = state => {
  return {
    productsReducerState: state.productsReducerState
  };
};

/**
 * Gracias a este método se pueden cambiar los estados globales
 * también permite acceder a las solicitudes del Epic para su
 * procesamiento en el backend
 * @param {*} dispatch 
 */
const mapDispatchToProps = dispatch => {
  return {
    setMessageSaveStateProduct: messageSaveStateProduct => dispatch(setMessageSaveStateProduct(messageSaveStateProduct)),
    requestGetProductCategory: () => bindActionCreators(dispatch(requestGetProductCategory()), dispatch),
    requestGetMeasureUnit: () => bindActionCreators(dispatch(requestGetMeasureUnit()), dispatch),
    requestSaveProduct: dataProduct => bindActionCreators(dispatch(requestSaveProduct(dataProduct)), dispatch),
  };
};

/**
 * Responde con el componente general del Usuario en su parte del formulario de datos
 */
export default connect(mapStateToProps, mapDispatchToProps)(UsersDeliveryPoint);